import { createTheme } from "@mui/material/styles";
import "./fonts.css";

const theme = createTheme({
  palette: {
    mode: "light",
    primary: {
      main: "#08adc2",
    },
    background: {
      default: "#fff",
      paper: "#fff",
    },
    text: {
      primary: "#212529",
    },
  },
  typography: {
    fontFamily: "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;",
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          textTransform: "none",
        },
      },
    },
  },
});

export default theme;
